// extracted by mini-css-extract-plugin
module.exports = {"scaleDesc":"styles_scaleDesc__1A2Kv"};